//
export const DataTypes = {
    Integer: "integer",
    Text: "text",
    DateTime: "datetime",
    Array: "array",
    Image: "image",
    Icon: "icon",
    File: "file",
    Location: "location",
    Boolean: "boolean"
}

//
export const FormTypes = {
    TextInput: "text-input",
    Textarea: "textarea",
    Select: "select",
    Checkbox: "checkbox",
    Hidden: "hidden",
    Datepicker: "datepicker",
    ArrayEditor: "array-editor",
    Upload: "upload",
    Icon: "icon",
    Map: "map",
    HtmlIframe: "iframe"
}
